import { z } from 'zod';
import { amountSchema, currencyCodeSchema, cursorQuerySchema, uuidSchema } from './common';

const i18nTextSchema = z.object({
  ko: z.string().min(1).max(200),
  ja: z.string().min(1).max(200),
});

export const upsertProductSchema = z.object({
  titleI18n: i18nTextSchema,
  descriptionI18n: z
    .object({ ko: z.string().max(4000), ja: z.string().max(4000) })
    .optional(),
  originCountry: z.enum(['KR', 'JP']),
  priceAmount: amountSchema,
  currency: currencyCodeSchema,
  categoryId: uuidSchema.optional(),
  images: z.array(z.string().max(500)).max(10).default([]),
  stock: z.number().int().min(0).nullable().default(null),
  status: z.enum(['draft', 'published', 'archived']).default('draft'),
  isFeatured: z.boolean().default(false),
  sortOrder: z.number().int().default(0),
  sourceUrl: z.string().url().max(1000).optional(),
});
export type UpsertProductInput = z.infer<typeof upsertProductSchema>;

export const listProductsQuerySchema = cursorQuerySchema.extend({
  q: z.string().max(100).optional(),
  categoryId: uuidSchema.optional(),
});
export type ListProductsQuery = z.infer<typeof listProductsQuerySchema>;
